export const filePlatforms = { windows: 'Windows', linux: 'Linux', macos: 'macOS', android: 'Android', other: 'Другое' };
